import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Modal, Tabs } from "antd";
import MerchantLayout from "../../layout/MerchantLayout";
import MerchantProducts from "./product";
import MerchantProductCategory from "./category";
import { SubscriptionInfo, UserInfo } from "../../../context";
import axios from "axios";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import MerchantProductDiscount from "./discount";
import MerchantProductSubCategory from "./subcategory";
import MerchantOtherProviderTransactionProducts from "./other-provider-transaction-product";
import MerchantInventoryReport from "./inventory-report";

const MerchantEmployee = () => {
  const [categoryList, setCategoryList] = useState({ data: [], ready: false });
  const [subCategoryList, setSubCategoryList] = useState({
    data: [],
    ready: false,
  });
  const { userData, handleLogoutTkn } = useContext(UserInfo);
  const { subscriptionDetails } = useContext(SubscriptionInfo);
  const dateNow = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  const navigate = useNavigate();

  const items = [
    {
      key: "1",
      label: `Product`,
      children: (
        <MerchantProducts
          categoryList={categoryList}
          subCategoryList={subCategoryList}
          // rerun={() => getProductCategory()}
          limit={subscriptionDetails.data.subsmerchantfeat.sku_limit}
        />
      ),
    },

    //ALLOW ADD FOOD PANDA /GRAB PUNCHTRANX
    userData.data.usersmerpermission.find(
      ({ permission }) => permission === "allow-punching-transaction"
    )
      ? {
          key: "5",
          label: `Other Product`,
          children: (
            <MerchantOtherProviderTransactionProducts
              limit={subscriptionDetails.data.subsmerchantfeat.sku_limit}
            />
          ),
        }
      : null,

    {
      key: "2",
      label: `Category`,
      children: (
        <MerchantProductCategory
          categoryList={categoryList}
          rerun={() => getProductCategory()}
          limit={subscriptionDetails.data.subsmerchantfeat.sku_limit}
        />
      ),
    },

    userData.data.usersmerpermission.find(
      ({ permission }) => permission === "allow-sub-category"
    )
      ? {
          key: "4",
          label: `Station`,
          children: (
            <MerchantProductSubCategory
              subCategoryList={subCategoryList}
              rerun={() => getProductSubCategory()}
              limit={subscriptionDetails.data.subsmerchantfeat.sku_limit}
            />
          ),
        }
      : null,
    {
      key: "3",
      label: `Discount`,
      children: (
        <MerchantProductDiscount
          limit={subscriptionDetails.data.subsmerchantfeat.sku_limit}
        />
      ),
    },
    {
      key: "6",
      label: `Inventory Report`,
      children: (
        <MerchantInventoryReport
        // limit={subscriptionDetails.data.subsmerchantfeat.sku_limit}
        />
      ),
    },
  ];

  const getProductCategory = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/product-category-list", { params })
      .then((response) => {
        const data = response.data;
        setCategoryList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const getProductSubCategory = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/product-sub-category-list", { params })
      .then((response) => {
        const data = response.data;
        setSubCategoryList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getProductCategory();
    getProductSubCategory();
  }, [getProductCategory, getProductSubCategory]);

  return (
    <MerchantLayout>
      <Tabs defaultActiveKey="1" items={items} />

      <Modal
        title="Subscription has ended."
        centered
        open={dateNow > subscriptionDetails.data.plan_expiry}
        // open={false}
        footer={null}
        width={350}
        closable={false}
      >
        <div style={{ display: "flex" }}>
          <div style={{ flexGrow: 1 }} />
          <Button
            style={{ marginRight: 5 }}
            onClick={() => navigate("/renew-subscription")}
          >
            Renew
          </Button>
          <Button type="primary" onClick={() => handleLogoutTkn()}>
            Logout
          </Button>
        </div>
      </Modal>
    </MerchantLayout>
  );
};

export default MerchantEmployee;
